var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef, AfterViewInit } from '@angular/core';
import { UserService } from 'app/services/user.service';
import { CommonTableService } from 'app/services/common-table.service';
import { AdminService } from 'app/services/admin.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { EditSubAgencyModalComponent } from './edit-sub-agency-modal/edit-sub-agency-modal.component';
import { MatDialogConfig } from '@angular/material';
import { AddSubAgencyModalComponent } from './add-sub-agency-modal/add-sub-agency-modal.component';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CommonFunctionService } from 'app/services/common-function.service';
import { AppSettings } from 'app/app.settings';
import { AppinfoService } from 'app/services/appinfo.service';
import { PaneControlService } from 'app/services/pane-control.service';
var ConfigSubAgenciesComponent = /** @class */ (function () {
    function ConfigSubAgenciesComponent(toastr, adminService, appinfoService, authService, commonFunction, modalService, tableService, paneService, userService) {
        this.toastr = toastr;
        this.adminService = adminService;
        this.appinfoService = appinfoService;
        this.authService = authService;
        this.commonFunction = commonFunction;
        this.modalService = modalService;
        this.tableService = tableService;
        this.paneService = paneService;
        this.userService = userService;
        this.subAgencies = [];
        // rows without filter
        this.unfilteredRows = [];
        //
        this.rows = [];
        this.selectedRows = [];
        this.searchStr = '';
        this.agencyNameCol = 'agencyName';
        this.agencyAdminEmailCol = 'agencyEmail';
        this.agencyIdCol = 'agencyId';
        this.operationsCol = 'operations';
        this.isNewAgencyCol = 'isNewUser';
    }
    ConfigSubAgenciesComponent.prototype.removeSubAgency = function (agencyId) {
        return __awaiter(this, void 0, void 0, function () {
            var agency, options, data, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        agency = this.subAgencies.find(function (a) { return a.id === agencyId; });
                        options = this.modalService.confirmModalOptions;
                        data = {
                            message: 'Are you sure you want to delete this sub agency -- ' + agency.name + '?'
                        };
                        options.data = data;
                        return [4 /*yield*/, this.modalService.openModalWindow(ConfirmModalComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 6];
                        this.commonFunction.setLoadingSpinner(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.adminService.deleteCustomer(agencyId)];
                    case 3:
                        _a.sent();
                        this.toastr.success('Successfully deleted.');
                        this.updateSubAgenciesTable();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonFunction.setLoadingSpinner(false);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ConfigSubAgenciesComponent.prototype.editSubAgency = function (agencyId) {
        return __awaiter(this, void 0, void 0, function () {
            var agency, data, options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        agency = this.subAgencies.find(function (a) { return a.id === agencyId; });
                        data = {
                            shortName: agency.name
                        };
                        options = {
                            data: data,
                            width: '450px',
                            height: '200px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(EditSubAgencyModalComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (result && result !== agency.name) {
                            this.adminService.updateCustomer(result, agency.id);
                            this.updateSubAgenciesTable();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigSubAgenciesComponent.prototype.addSubAgency = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, result, registerRsp, newCustomerId, newUserId, subId, roleId, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            width: '730px',
                            height: '650px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(AddSubAgencyModalComponent, options)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 8];
                        this.commonFunction.setLoadingSpinner(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, this.authService.registerAgency(result.name, result.adminEmail, result.pw, result.desc, this.userService.customerInfo.id)];
                    case 3:
                        registerRsp = _a.sent();
                        return [4 /*yield*/, this.authService.sendVerifyEmail(result.adminEmail, result.name)];
                    case 4:
                        _a.sent();
                        newCustomerId = registerRsp.data[0].cus_id;
                        newUserId = registerRsp.data[0].usr_id;
                        // TODO
                        // result.cusProps.customerShortName = result.name
                        this.adminService.updateCustomer(result.cusProps, newCustomerId);
                        subId = this.userService.getUserInfo().subscriptionId;
                        roleId = this.appinfoService.rolesByApp[AppSettings.appName].find(function (r) { return r.desc === 'ADMINISTRATOR'; }).rol_id;
                        return [4 /*yield*/, this.adminService.addUserSubscription(newUserId, subId, roleId)];
                    case 5:
                        _a.sent();
                        this.toastr.info('An email has been sent for verification.');
                        return [3 /*break*/, 7];
                    case 6:
                        err_2 = _a.sent();
                        console.log(err_2.message);
                        this.toastr.error('Failed to add agency.');
                        return [3 /*break*/, 7];
                    case 7:
                        this.commonFunction.setLoadingSpinner(false);
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ConfigSubAgenciesComponent.prototype.updateSubAgenciesTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.updateToken()];
                    case 1:
                        _a.sent();
                        this.subAgencies = this.userService.customerInfo.children;
                        this.setRows();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigSubAgenciesComponent.prototype.search = function () {
        this.rows = this.filterRows();
    };
    // Filter rows with searchStr
    ConfigSubAgenciesComponent.prototype.filterRows = function () {
        var _this = this;
        if (this.searchStr) {
            return this.unfilteredRows.filter(function (r) {
                // Always show newSubAgency row
                if (r[_this.isNewAgencyCol]) {
                    return true;
                }
                if (r[_this.agencyNameCol]) {
                    return r[_this.agencyNameCol].toLowerCase().indexOf(_this.searchStr.toLowerCase()) > -1;
                }
                return false;
            });
        }
        else {
            return this.unfilteredRows;
        }
    };
    ConfigSubAgenciesComponent.prototype.setRows = function () {
        var _this = this;
        var rows = [];
        this.subAgencies.forEach(function (a) {
            var row = {};
            row[_this.agencyNameCol] = a.name;
            row[_this.agencyAdminEmailCol] = a.adminEmails.join();
            row[_this.agencyIdCol] = a.id;
            rows.push(row);
        });
        // Add new sub agency row
        var newUserRow = {};
        newUserRow[this.isNewAgencyCol] = true;
        rows.push(newUserRow);
        this.unfilteredRows = rows;
        this.rows = this.filterRows();
    };
    // Set table columns
    ConfigSubAgenciesComponent.prototype.setColumns = function () {
        var columns = [];
        // Add agency name column
        var agencyNameCol = this.tableService.setNewColumn(this.agencyNameCol, 'Sub Agency Name', {
            skipGdoCheck: true,
            // width: 200,
            isNameKeepCase: true,
            headerAlign: 'L'
        });
        columns.push(agencyNameCol);
        // Add agency name column
        var adminEmailCol = this.tableService.setNewColumn(this.agencyAdminEmailCol, 'Admin Users', {
            skipGdoCheck: true,
            // width: 200,
            isNameKeepCase: true,
            headerAlign: 'L'
        });
        columns.push(adminEmailCol);
        // Add operations column
        var operationsCol = this.tableService.setNewColumn(this.operationsCol, ' ', {
            align: 'R',
            headerAlign: 'R',
            skipGdoCheck: true,
            cellTemplate: this.operationsTempl
        });
        columns.push(operationsCol);
        this.columns = columns;
    };
    ConfigSubAgenciesComponent.prototype.ngOnInit = function () {
        // Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
        this.paneService.currPane.next({
            paneType: 'config',
            submenu: 'configSubAgencies'
        });
        this.subAgencies = this.userService.customerInfo.children;
    };
    ConfigSubAgenciesComponent.prototype.ngAfterViewInit = function () {
        this.setColumns();
        this.setRows();
    };
    return ConfigSubAgenciesComponent;
}());
export { ConfigSubAgenciesComponent };
